<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="showProfile">
                <v-icon>mdi-file-document-box-outline</v-icon>
            </v-btn>
        </template>
            <v-card flat v-if='player'>
                {{ player }}
                <!-- <v-sheet
                    v-if="(player.wins+player.loses) > 0"
                    class="v-sheet--offset mx-auto"
                    color="cyan"
                    max-width="calc(100%)"
                >
                    <v-sparkline
                        :labels="history"
                        :value="history"
                        stroke-linecap="round"
                        color="white"
                        type="trend"
                        line-width="2"
                        padding="16"
                        height="100"
                        auto-draw
                    ></v-sparkline>
                </v-sheet>
                <v-list  v-if="(player.wins+player.loses) > 0">
                    <v-subheader>상대와의 전적</v-subheader>
                    <v-divider inset></v-divider>
                    <v-list-item v-for="(opponent, i) in opponents" :key="i" @click="goToProfile()">
                        <v-list-item-icon>
                            <v-btn small text>{{opponent.loses}}- {{opponent.wins}}</v-btn>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>
                                <v-progress-linear height="6" color="blue-grey accent-4" :value="(opponent.loses / (opponent.loses + opponent.wins)) * 100">
                                </v-progress-linear>
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content></v-list-item-content>
                        <v-list-item-content>
                            <v-list-item-title v-text="opponent.name"></v-list-item-title>
                            <v-list-item-subtitle v-text="opponent.alias"></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-avatar>
                            <v-img :src="opponent.avatar"></v-img>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-list> -->
            </v-card>
    </v-dialog>
</template>

<script>
import db from '@/fb'

export default {
    name: 'Profile',
    props: [ 'playerId', 'players'],
    data: () => ({
        dialog: false,
        player: null
    }),
    methods: {
        showProfile(){
            db.collection('users').doc(this.playerId).get().then(snapshot => {
                this.player = snapshot.data()
            })
        }
    }
}
</script>

<style>

</style>